@if (isPermission === false) {
  <div class="container">
    <h1 i18n="@@404PageNotFound">{{ 'TRANSLATE.PERMISSIONLESS.USER' | translate }}</h1>
    <p i18n="@@couldNotFindThePage">{{ 'TRANSLATE.YOU.ARE.ALLOWED.TO.ACCESS.SCREEN' | translate }}</p>
    <i class="far fa-sad-tear fa-8x mt-2" aria-hidden="true"></i>
    <a [routerLink]="['/']" class="mt-2 ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
      <span class="ui-button-text ui-clickable" i18n="@@goToHomepage">{{ 'TRANSLATE.HOME.PAGE' | translate }}</span>
    </a>
  </div>
}

@if (isPermission === true) {
  <div class="container">
    <div class="container-header">
      <span class="title">{{ 'TRANSLATE.SALES.CHANNEL' | translate }}</span>
    </div>

    <div class="sales-channel-body">
      <section class="sales-channel-shell">
        <article class="channel-card" aria-label="Sales channel visual">
          <div class="channel-visual">
            <img class="image" src="./../../../assets/image/vin/telemarketing.png" alt="">
          </div>
          <span class="channel-badge">{{ 'TRANSLATE.UPPERCASE.TELEMARKETING' | translate }}</span>
        </article>

        <article class="channel-form-card" aria-label="Chassis entry">
          <span class="chassi-label" [innerHTML]="chassisPromptLabel"></span>

          <div class="chassi-input-row">
            <input pInputText type="text" class="chassi-input" (keyup)="onKeyUp($event)"
              [(ngModel)]="chassi" maxlength="17" [style]="inputChassiStyleCss"
              [attr.aria-label]="'TRANSLATE.INSERT.THE.CHASSIS' | translate" />
          </div>
        </article>
      </section>

        <!--
        15 DE JAN. DE 2024 ATENÇÃO: ESSE CAMPO DEVE PERMANECER COMENTADO ATÉ DEFINIREM QUANDO SERÁ UTILIZADO
        <div class="col-12" style="text-align: center;">
          <span class="chassi-label">{{ 'TRANSLATE.CHASSI.INFORMATION' | translate }}</span>
        </div>
        <div class="col-12" style="text-align: center;">
          <table align="center">
            <tr>
              <td>
                <span style="color: #1874CD; font-weight: bold;">{{ 'TRANSLATE.NOT' | translate }}</span>
              </td>
              <td>&nbsp;&nbsp;</td>
              <td>
                <p-inputSwitch disabled="true" [(ngModel)]="isChassi"></p-inputSwitch>
              </td>
              <td>&nbsp;&nbsp;</td>
              <td>
                <span style="color: #1874CD; font-weight: bold;">{{ 'TRANSLATE.YES' | translate }}</span>
              </td>
            </tr>
          </table>
          <hr class="margin-top-5" />
        </div>
        -->

      <div class="button-position">
        <button pButton id="btnAdvance" class="action-button app-filter-button" (click)="buttonNext()" type="button"
          [disabled]="vinValidate?.validated !== isValidChassi || errorMessageVin === 'VIN.ERROR.SAVE_VECTOR' ">
          <i class="pi pi-arrow-right" aria-hidden="true"></i>
          <span class="action-button-label">{{ 'TRANSLATE.ADVANCE' | translate }}</span>
        </button>
      </div>
    </div>
  </div>
}